import { FormControl, MenuItem, Select, InputLabel } from '@material-ui/core'
import React, { useMemo } from 'react'
import { ensureMappingStructure, getMappingValue } from '../../../utils/databaseMapping'

export default ({ variableDialog, setvariableDialog, index, databaseObjectModels }) => {
  const objectModels = databaseObjectModels.map((model) => model.definitionJson.name)

  // Memoize the current value to avoid recalculating on every render
  const currentValue = useMemo(() => {
    return getMappingValue(variableDialog, index)
  }, [variableDialog, index])

  const handleChange = (e) => {
    let result = { ...variableDialog }
    const mapping = ensureMappingStructure(result, index)
    mapping.database_object_model_name = e.target.value
    result.database_object_model_name = e.target.value

    setvariableDialog(result)
  }

  return (
    <FormControl size="small" style={{ width: 300, backgroundColor: 'white' }} variant="outlined">
      <InputLabel>Modèle d'objet de la base de données</InputLabel>
      <Select
        label="Modèle d'objet"
        value={currentValue}
        onChange={handleChange}
      >
        <MenuItem keu="0" value="">
          <em>Aucun</em>
        </MenuItem>
        {objectModels.map((elem, key) => (
          <MenuItem key={key + 1} value={elem}>
            {elem}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  )
}
